import { HttpEvent, HttpHandler, HttpHeaderResponse, HttpHeaders, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SnackbarService } from '../../_services/shared/snackbar.service';
import { EInterceptorOptionsHTTPHeaders } from './EInterceptorOptionsHTTPHeaders';
import { tap } from 'rxjs/operators';

@Injectable()
export class SavedInterceptor implements HttpInterceptor {
  constructor(private snackbarService: SnackbarService) {}
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const ignore = (httpRequest.headers.has(EInterceptorOptionsHTTPHeaders.SupressSavedInterceptor) || httpRequest.headers.get(EInterceptorOptionsHTTPHeaders.ShowSavedNotification)?.valueOf() === "false")
    if(ignore){
      return next.handle(httpRequest)
    }
    else {
      return next.handle(httpRequest).pipe(
        tap((httpEvent: HttpSentEvent | HttpResponse<any> | HttpUserEvent<any> |  HttpHeaderResponse | HttpProgressEvent )=>{
          if(httpEvent instanceof HttpResponse && httpEvent.ok){
            const method = httpRequest.method
            if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
              this.snackbarService.open()
            }
            }
        })
      )
    }
  }
    // Old implementation, preserved for posterity. MM 9.9.24 
    // let showNotification = req.headers.get(this.notificationHeader);
    // if (showNotification !== null) {
    //   showNotification = JSON.parse(showNotification);

    //   if (showNotification) {
    //     this.showSavedNotification = true;
    //   }

    //   req = this.removeHeader(req, req.headers);
    // }
    // return Observable.create(observer => {
    //   const subscription = next.handle(req)
    //     .subscribe(
    //       event => {
    //         if (event instanceof HttpResponse) {
    //           /*
    //            there are some requests that perform a 'save' operation but are using different request methods, see isCertifiedApprover
    //            endpoint.
    //            The user basic search endpoint also is a POST, this is intentional.
    //            Given that, the only option we have is to attach the header to the requests we want to display the saved notification on, or
    //            attach this to every request that could feasibly be a 'save' and use the value to determine if we should display or not.
    //           */
    //           if (req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH') {
    //             // if the request was of an 'update/create' type, but does not have the notification header, display the notification.
    //             if (showNotification === null) {
    //               // 200 ok, 201 created, 202 accepted
    //               if (event.status === 200 || event.status === 201 || event.status === 202) {
    //                 this.snackbarService.open();
    //               }
    //             }
    //           }
    //           if (this.showSavedNotification) {
    //             this.snackbarService.open();
    //             this.showSavedNotification = false;
    //           }
    //           observer.next(event);
    //         }
    //       },
    //       err => {
    //         observer.error(err);
    //       },
    //       () => {

    //         observer.complete();
    //       });
    //   // teardown logic in case of cancelled requests
    //   return () => {
    //     subscription.unsubscribe();
    //   };
    // });
  
}
